import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    wrap: {
        paddingBottom: theme.typography.pxToRem(0),
        height: '100%',
        flexGrow: 1
    }
}));
